import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchTeams } from 'actions/team';
import Text from 'components/Text';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
export var NudgeAudience = function NudgeAudience(_ref) {
  var audience = _ref.audience,
    teamIds = _ref.teamIds;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchTeams = useFetchTeams({
      teamIds: teamIds
    }),
    items = _useFetchTeams.items;
  if (audience === 'all' || !(teamIds !== null && teamIds !== void 0 && teamIds.length)) {
    return /*#__PURE__*/React.createElement(Text, null, t('state_everyone'));
  }
  return /*#__PURE__*/React.createElement(DetailsDropdown, {
    titleKey: t('content_type_team_plural'),
    listItems: items.map(function (team) {
      return /*#__PURE__*/React.createElement(Text, {
        bold: true,
        key: team.id
      }, team.name);
    }),
    listLayout: "stack"
  }, t('teams_count', {
    count: items.length
  }));
};
export default NudgeAudience;